import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

// Components
import Input from '../form/Input';
import SelectInput from '../form/SelectInput';
import TextArea from '../form/TextArea';
import { useSubmitServicesFormMutation } from '../../redux/slices/formSlice';

// Misc
import * as v from '../../modules/validators';
import styles from './ServicesForm.module.postcss';
import formStyles from '../../../stylesheets/public/components/Forms.module.postcss';

function ServicesForm({ handleSubmit, submitting, valid, formType, change }) {
  const isResidential = formType === 'residential';
  const group = isResidential ? 'Community' : 'Team';
  const members = isResidential ? 'residents' : 'employees';

  const [submitServicesForm, { isLoading, isSuccess, isError }] = useSubmitServicesFormMutation();

  useEffect(() => {
    change('form_type', formType);
  }, [change, formType]);

  const submitForm = async (data) => {
    try {
      await submitServicesForm(data).unwrap();
    } catch (err) {
      console.error('Failed to submit Services Form: ', err);
    }
  };

  if (isLoading) {
    return <p>Sending your request…</p>;
  }
  if (isSuccess) {
    return <p>Request sent. We&#39;ll be in touch.</p>;
  }
  if (isError) {
    return <p>We couldn&#39;t send your request. Try again.</p>;
  }

  return (
    <form
      onSubmit={handleSubmit(submitForm)}
      className={formStyles.FlexForm + ' ' + styles.ServicesForm}
    >
      <div className={styles.ServicesForm_flex}>
        <div>
          <div className='Fieldset'>
            <span className={styles.Required}>* required</span>
            <Field
              label='Name'
              name='name'
              component={Input}
              type='text'
              placeholder='Full Name'
              validate={[v.required]}
            />
          </div>
          <div className='Fieldset'>
            <span className={styles.Required}>* required</span>
            <Field
              label='Email'
              name='email'
              component={Input}
              type='text'
              placeholder='Your Best Contact Email'
              validate={[v.required, v.email]}
            />
          </div>
          <div className='Fieldset'>
            <Field
              label='City'
              name='city'
              component={Input}
              type='text'
              placeholder='Where Your Office is Located'
            />
          </div>
          <div className='Fieldset'>
            <Field
              label='Phone number'
              name='phone'
              component={Input}
              type='text'
              placeholder='(___) ___ ____'
            />
          </div>
        </div>

        <div>
          { formType === 'breweries' &&
            <div className='Fieldset'>
              <Field
                label='Company Name'
                name='company_name'
                component={Input}
                type='text'
                placeholder='Enter company name...'
              />
            </div>
          }
          { formType !== 'breweries' &&
            <div className='Fieldset'>
              <Field
                label={`${group} size`}
                name='team_size'
                options={[
                  { label: `10-49 ${members}`, value: '10-49' },
                  { label: `50-249 ${members}`, value: '50-249' },
                  { label: `250-999 ${members}`, value: '250-999' },
                  { label: `1000+ ${members}`, value: '1000+' },
                ]}
                valueKey='value'
                labelKey='label'
                component={SelectInput}
                limit={1}
                placeholder={`Number of ${members[0].toUpperCase() + members.slice(1)} You're Feeding`}
                type='input'
              />
            </div>
          }
          <div className='Fieldset'>
            <Field
              label='Additional notes'
              name='notes'
              component={TextArea}
              placeholder='Any Special Requests or Details'
            />
          </div>
          <button
            className='Button'
            disabled={!valid || submitting}
            type='submit'
          >
            Send request
          </button>
        </div>
      </div>
    </form>
  );
}

ServicesForm.propTypes = {
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  change: PropTypes.func,
  formType: PropTypes.string,
};

export default reduxForm({ form: 'services' })(ServicesForm);
